
import { defineComponent, PropType } from "vue";
import { SortOrderOption } from "../models/sortOrderOptions";

export default defineComponent({
  props: {
    optionValue: {
      type: Object as PropType<SortOrderOption>,
      required: true,
      default: undefined
    },
    isSelected: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup(props, context) {
    const optionSelected = () => {
      if (!props.isSelected) {
        context.emit("sortChanged", props.optionValue);
      }
    };

    return {
      optionSelected
    };
  }
});
